export const SAFETY_PROFILE_SECTION_KEYS = [
  "photo_header",
  "about",
  "rate_band",
  "incidents_and_filings",
  "program_evidence",
  "documents",
  "frequently_asked",
  "contact_addresses",
] as const;
export type SafetyProfileSectionKey = (typeof SAFETY_PROFILE_SECTION_KEYS)[number];

export const SAFETY_PROFILE_HEADLINE_KEYS = ["emr", "trir", "dart"] as const;
export type SafetyProfileHeadlineKey = (typeof SAFETY_PROFILE_HEADLINE_KEYS)[number];

const SAFETY_PROFILE_INCIDENT_STAT_KEYS = [
  "recordable_injuries",
  "days_away_or_restricted_cases",
  "days_since_recordable",
] as const;
const SAFETY_PROFILE_PROGRAM_STAT_KEYS = [
  "toolbox_talks",
  "corrective_actions_closed",
  "observations",
  "near_miss_reports",
] as const;

export const SAFETY_PROFILE_STAT_KEYS = [
  ...SAFETY_PROFILE_INCIDENT_STAT_KEYS,
  ...SAFETY_PROFILE_PROGRAM_STAT_KEYS,
] as const;
export type SafetyProfileStatKey = (typeof SAFETY_PROFILE_STAT_KEYS)[number];

/** Every individually toggleable stat across the rate, incident, and program sections. */
export const SAFETY_PROFILE_STAT_VISIBILITY_KEYS = [
  ...SAFETY_PROFILE_HEADLINE_KEYS,
  ...SAFETY_PROFILE_STAT_KEYS,
] as const;
export type SafetyProfileStatVisibilityKey = (typeof SAFETY_PROFILE_STAT_VISIBILITY_KEYS)[number];

/** Which toggleable stats each section owns, so the editor can group per-stat controls. */
export const SAFETY_PROFILE_SECTION_STAT_KEYS = {
  rate_band: SAFETY_PROFILE_HEADLINE_KEYS,
  incidents_and_filings: SAFETY_PROFILE_INCIDENT_STAT_KEYS,
  program_evidence: SAFETY_PROFILE_PROGRAM_STAT_KEYS,
} as const satisfies Partial<Record<SafetyProfileSectionKey, readonly SafetyProfileStatVisibilityKey[]>>;

export type SafetyProfilePublishSettings = {
  enabled: boolean;
};

export type SafetyProfileFaqItem = {
  question: string;
  answer: string;
};

/** A "get in touch" contact row: a free-text purpose and the email it routes to. */
export type SafetyProfileContact = {
  label: string;
  email: string;
};

/** A header photo the customer authored, carrying both its stored file id and a display URL. */
export type SafetyProfilePhoto = {
  file_id: string;
  url: string;
};

/** A document reference on the profile, resolved with its display label and download URL. */
export type SafetyProfileDocument = {
  file_id: string;
  label: string;
  url: string;
};

export const MAX_SAFETY_PROFILE_HEADER_PHOTOS = 3;

export const MAX_SAFETY_PROFILE_ABOUT_LENGTH = 5000;
